import type { ParseKeys } from 'i18next';

import jokerCardCc from '../../../../../assets/card-war/joker-card-cc.webp';
import jokerCardSc from '../../../../../assets/card-war/joker-card-sc.webp';
import type { MetagamesEventByCoin } from '../../../../../dto/metagames.types';
import type { CoinType } from '../../../../../stores/cointype/CoinTypeStore';
import type { MetagameWidgetType } from '../../../types';

// A type, not an interface: it has to be assignable to CSSProperties.
export type FeatureColors = {
  background: string;
  borderColor: string;
};

export interface MetagameFeatureConfig {
  featureKey: string;
  art: Record<CoinType, string>;
  colors: Record<CoinType, FeatureColors>;
  labelKey: ParseKeys;
}

/**
 * A metagame's event-scoped feature balance shown on its lobby widget: the feature's art once the player
 * holds any, its count in the counter when the main balance is 0, and a pill on the wide widget.
 */
export const METAGAME_FEATURES: Partial<Record<MetagameWidgetType, MetagameFeatureConfig>> = {
  cardWar: {
    featureKey: 'card_war_joker',
    art: { GC: jokerCardCc, SC: jokerCardSc },
    colors: {
      GC: { background: '#650042', borderColor: '#ffd730' },
      SC: { background: '#023769', borderColor: '#07d180' },
    },
    labelKey: 'metagameWidget.jokers',
  },
};

export const featureBalance = (eventByCoin: MetagamesEventByCoin, featureKey: string) =>
  eventByCoin.features?.find((feature) => feature.featureKey === featureKey)?.balance ?? 0;

export const formatFeatureBalance = (balance: number) => (balance > 99 ? '99+' : `${balance}`);

export const MEGA_DICE_FEATURE_KEY = 'mega_dice';
export const GOLDEN_DICE_FEATURE_KEY = 'golden_dice';

// Features that are more of the metagame's own currency, so its counter shows them added to the regular balance
// (Chewy's Mega and Golden Dice are dice too). They only ever come on their own metagame's event.
const BALANCE_FEATURE_KEYS = [MEGA_DICE_FEATURE_KEY, GOLDEN_DICE_FEATURE_KEY];

export const metagameBalance = (eventByCoin: MetagamesEventByCoin) =>
  eventByCoin.balance +
  BALANCE_FEATURE_KEYS.reduce((sum, featureKey) => sum + featureBalance(eventByCoin, featureKey), 0);
